{
  "collapse": "Σύμπτυξη",
  "expand": "Ανάπτυξη"
}
